import React from "react";

import TimerIcon from "@mui/icons-material/Timer";
import "../../styles/ruleConfig.css";
import moment from "moment";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

//Components
import NewUserApproval from "../../components/approval/NewUserApproval";
import UserEditApproval from "../../components/approval/UserEditApproval";
import UserRevokeApproval from "../../components/approval/UserRevokeApproval";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const UserApproval = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="dashboard-container">
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingRight: "15px",
          }}
        >
          <div>
            <h2 className="dash-header">User Approval</h2>
          </div>
          <div style={{ display: "flex", columnGap: "20px" }}>
            <div className="time">
              <TimerIcon />
              <p>Time: {moment().format("h:mm:ss a")}</p>
            </div>
          </div>
        </div>

        <div>
          <p className="ruleConfig-header">
            Simply displays a list of users and their roles that has been added
            to the system. You can approve or reject any of the users.
          </p>
        </div>
        <div className="ruleConfig-tabs">
          <Tabs
            value={value}
            onChange={handleChange}
            TabIndicatorProps={{
              sx: { backgroundColor: "#255cff", height: 4 },
            }}
            sx={{
              width: "90%",
              margin: "0 auto",
              height: "72px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
              alignItems: "center",
              "& button:active": { color: "#255cff" },
              "& button.Mui-selected": { color: "#255cff" },
            }}
          >
            <Tab
              label="New User"
              {...a11yProps(0)}
              sx={{
                fontSize: "20px",
                color: "#BBBBBB",
                fontWeight: "600",
                fontFamily: "Open-Sans",
              }}
            />
            <Tab
              label="Update User"
              {...a11yProps(1)}
              sx={{
                fontSize: "20px",
                color: "#BBBBBB",
                fontWeight: "600",
                fontFamily: "Open-Sans",
              }}
            />
            <Tab
              label="Revoke User"
              {...a11yProps(2)}
              sx={{
                fontSize: "20px",
                color: "#BBBBBB",
                fontWeight: "600",
                fontFamily: "Open-Sans",
              }}
            />
          </Tabs>
        </div>

        <Box sx={{ width: "100%" }}>
          <TabPanel value={value} index={0}>
            <NewUserApproval />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <UserEditApproval />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <UserRevokeApproval />
          </TabPanel>
        </Box>
      </div>
      <p className="copyright-text">&copy; 2024 Breeze Transaction Gateway. </p>
    </div>
  );
};

export default UserApproval;
